import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import HomePage from './pages/HomePage';
import MatchCenter from './pages/MatchCenter';
import PlayerProfile from './pages/PlayerProfile';
import TalentGraph from './pages/TalentGraph';
import USACricketAtlas from './pages/USACricketAtlas';
import MemeStudio from './pages/MemeStudio';
import LeaguePage from './pages/LeaguePage';
import AdminDashboard from './pages/AdminDashboard';
import PodcastsPage from './pages/PodcastsPage';
import SocialMediaPage from './pages/SocialMediaPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PlayerDashboard from './pages/PlayerDashboard';
import JournalEntryForm from './pages/JournalEntryForm';
import JournalTimeline from './pages/JournalTimeline';
import JournalDetailPage from './pages/JournalDetailPage';
import ProtectedRoute from './components/ProtectedRoute';
import CricketBlogs from './pages/CricketBlogs';
import CommunityPointsPage from './pages/CommunityPointsPage';
import PricingPage from './pages/PricingPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import GoalsPage from './pages/GoalsPage';
import VideoUploadPage from './pages/VideoUploadPage';
import CoachDashboard from './pages/CoachDashboard';
import FindCoachPage from './pages/FindCoachPage';
import MyTasksPage from './pages/MyTasksPage';
import SubscriptionSuccessPage from './pages/SubscriptionSuccessPage';
import { Toaster } from 'sonner';
import { ThemeProvider } from './context/ThemeContext';
import { AuthProvider } from './context/AuthContext';
import { HouseholdProvider } from './context/HouseholdContext';
import OnboardingFlow from './pages/OnboardingFlow';
import AthleteDashboard from './pages/AthleteDashboard';
import PracticePlan from './pages/PracticePlan';
import DrillLibrary from './pages/DrillLibrary';
import ProClipLibrary from './pages/ProClipLibrary';
import AdminClips from './pages/AdminClips';
import InviteAcceptPage from './pages/InviteAcceptPage';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <HouseholdProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/onboarding" element={<OnboardingFlow />} />
              <Route path="/dashboard" element={<ProtectedRoute><AthleteDashboard /></ProtectedRoute>} />
              <Route path="/practice-plan" element={<ProtectedRoute><PracticePlan /></ProtectedRoute>} />
              <Route path="/drills" element={<ProtectedRoute><DrillLibrary /></ProtectedRoute>} />
              <Route path="/clips" element={<ProtectedRoute><ProClipLibrary /></ProtectedRoute>} />
              <Route path="/admin/clips" element={<ProtectedRoute><AdminClips /></ProtectedRoute>} />
              <Route path="/i/:token" element={<InviteAcceptPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/matches" element={<MatchCenter />} />
              <Route path="/matches/:id" element={<MatchCenter />} />
              <Route path="/players/:id" element={<PlayerProfile />} />
              <Route path="/talent-graph" element={<TalentGraph />} />
              <Route path="/atlas" element={<USACricketAtlas />} />
              <Route path="/memes" element={<MemeStudio />} />
              <Route path="/leagues/:id" element={<LeaguePage />} />
              <Route path="/admin" element={<AdminDashboard />} />
              <Route path="/podcasts" element={<PodcastsPage />} />
              <Route path="/social" element={<SocialMediaPage />} />
              <Route path="/blogs" element={<CricketBlogs />} />
              <Route path="/community-points" element={<CommunityPointsPage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/subscription-success" element={<SubscriptionSuccessPage />} />
              
              {/* Protected Routes - Require Login */}
              <Route path="/player-dashboard" element={<ProtectedRoute><PlayerDashboard /></ProtectedRoute>} />
              <Route path="/journal/new" element={<ProtectedRoute><JournalEntryForm /></ProtectedRoute>} />
              <Route path="/journal/edit/:id" element={<ProtectedRoute><JournalEntryForm /></ProtectedRoute>} />
              <Route path="/journal/timeline" element={<ProtectedRoute><JournalTimeline /></ProtectedRoute>} />
              <Route path="/journal/:id" element={<ProtectedRoute><JournalDetailPage /></ProtectedRoute>} />
              <Route path="/goals" element={<ProtectedRoute><GoalsPage /></ProtectedRoute>} />
              <Route path="/videos/upload" element={<ProtectedRoute><VideoUploadPage /></ProtectedRoute>} />
              <Route path="/coach-dashboard" element={<ProtectedRoute><CoachDashboard /></ProtectedRoute>} />
              <Route path="/find-coach" element={<ProtectedRoute><FindCoachPage /></ProtectedRoute>} />
              <Route path="/my-tasks" element={<ProtectedRoute><MyTasksPage /></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </div>
        </HouseholdProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;